import { render, staticRenderFns } from "./play-24.vue?vue&type=template&id=0bc18ea8&scoped=true"
import script from "./play-24.vue?vue&type=script&lang=js"
export * from "./play-24.vue?vue&type=script&lang=js"
import style0 from "./play-24.vue?vue&type=style&index=0&id=0bc18ea8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc18ea8",
  null
  
)

export default component.exports